import { useCallback, useEffect, useRef } from 'react'

import { useToolbarActions } from 'features/admin/datagrid/Toolbar/useToolbarActions'

type UseManageDataTablesStateProps = {
    objects: ObjectDto[]
    selectedObjectIdx: number
}

export function useManageDataTablesState({
    objects,
    selectedObjectIdx,
}: UseManageDataTablesStateProps) {
    const selectedObject = objects[selectedObjectIdx]
    const selectedObjectSid = selectedObject?._sid ?? ''

    const { toolbarModals, showImportData, showPermissions, showSettings, closeModal } =
        useToolbarActions({
            object: selectedObject,
        })
    const closeModalRef = useRef(closeModal)
    closeModalRef.current = closeModal

    const onOpenImportModal = useCallback(() => {
        showImportData()
    }, [showImportData])

    const onOpenPermissionsModal = useCallback(() => {
        showPermissions()
    }, [showPermissions])

    const onOpenSettingsModal = useCallback(() => {
        showSettings()
    }, [showSettings])

    // Close modals when the selected object changes.
    useEffect(() => {
        closeModalRef.current()
    }, [selectedObjectSid])

    return {
        onOpenImportModal,
        selectedObjectSid,
        onOpenPermissionsModal,
        toolbarModals,
        onOpenSettingsModal,
    }
}
